  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div [ngClass]="control.layout" *ngFor="let control of controls">
      <div *ngIf="control.title != ''" style="margin-bottom: 1rem;" class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <p class="title" [innerHTML]="control.title"></p>
      </div>
      <app-form-control [control]="control" [form]="form"></app-form-control>
    </div>
    <button id="gtmBnplValidarIdentidad" class="btn btn-azul btn-redondo" [disabled]="!form.valid || desabledButton" type="submit" >Continuar</button>
  </form>
